import { useEffect, useState } from 'react';
import { handleTrack } from '../../../../../utils/tracker';
import { BrandSlider } from '../../../../Molecules/brand-slider/index';
import RewardsDataService from '../../../../S/Rewards/Services/rewards.service';
import { rewardList } from '../../../../S/Rewards/rewards_category';
import { SectionHeader } from '../../../utils/section-header';
import { getSliderDataForRewards, splitArrayInHalf } from '../utils';

const getRewardCTA = (classes: string): JSX.Element => {
  return (
    <a
      className={classes}
      href="/s/rewards"
      onClick={(e) => handleTrack({ label: 'rewards', obj: e.target })}
    >
      View All Rewards →
    </a>
  );
};

const PartnerRewards = (): JSX.Element => {
  const [rewards, setRewards] = useState<rewardList[]>([]);
  useEffect(() => {
    RewardsDataService.getRewardsData()
      .then((response) => {
        setRewards(response.data);
      })
      .catch((e: Error) => {
        console.log('reawrds API failed', e);
      });
  }, []);

  const [firstHalf, secondHalf] = splitArrayInHalf(rewards);

  return (
    <div className="py-14 pb-6 sm:pb-0">
      <div className="wg-container">
        <SectionHeader
          align="left"
          heading="Its raining rewards!"
          description={
            <>
              File your ITR with us and get assured rewards from these top
              brands.{' '}
              <span className="sm:hidden">
                {getRewardCTA('text-blue-350 font-bold pl-2')}
              </span>
            </>
          }
        />
        {getRewardCTA(
          'text-blue-350 font-bold text-base mt-4 block xl:hidden lg:hidden md:hidden'
        )}
      </div>

      <div className="pt-4 max-w-screen-2xl mx-auto sm:pt-2">
        <BrandSlider
          brands={getSliderDataForRewards(firstHalf)}
          direction={'left'}
        />
        <BrandSlider brands={getSliderDataForRewards(secondHalf)} />
      </div>
    </div>
  );
};

export { PartnerRewards };
